import Carousel from 'react-bootstrap/Carousel';
import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const PhotoSlider = ({ slides, onClick }) => {

  return (
    <Carousel className="photo-slider custom-arrows" interval={null} draggable={false} nextIcon={<FontAwesomeIcon className="text-black" icon={faArrowRight} />} prevIcon={<FontAwesomeIcon className="text-black" icon={faArrowLeft} />}>
    {slides.map((slide, index) => (
      (slide?.objectUrl ? (
        <Carousel.Item className={"square"} key={index} onClick={onClick}>
          <img src={process.env.REACT_APP_SITE_URL + (slide?.objectUrl ?? "")} alt={slide?.name ?? ""} />
        </Carousel.Item>
      ) : null)
    ))} 
    </Carousel>
  )
}

export default PhotoSlider;
